const { IconButton } = require("@mui/material");

const IconWrapper = ({ icon, onClick }) => {
    return (
        <IconButton disableRipple onClick={onClick}>
            <img src={icon} alt="" />
        </IconButton>
    );
};

export default IconWrapper;
